export const ADDONS_WARNING_CONSTANTS = {
  SEAT: 'Select your free seat to proceed.',
  MEAL: 'Select your free meal to proceed.',
}

export const ADDONS_FREE_LABEL = 'Free'
export const ADDONS_ADDITIONAL_PREFIX = 'Additional'
export const ADDONS_SELECTED_COUNT_SUFFIX = 'selected'
export const ADDONS_MORE_OPTIONS_LABEL = 'options'

export const ADDONS_CTA = {
  CHANGE: 'Change',
  VIEW_BAGGAGE_OPTIONS: 'View baggage options',
  VIEW_MENU: 'View menu',
  SELECT_SEATS: 'Select seats',
  VIEW_ALL: 'View all',
} as const

export const ADDONS_JOURNEY_LABEL = {
  ONWARD: 'Onward',
  RETURN: 'Return',
} as const

export const ADDONS_BAGGAGE_COPY = {
  MODAL_TITLE: 'Add in-flight baggage to your journey',
  SUBTITLE: 'Baggage is cheaper when pre-booked',
  COLLAPSED_PROMPT: 'Carrying more luggage? Get extra check-in baggage',
  COLLAPSED_ADDED: 'Extra check-in baggage added',
  INLINE_TITLE: 'Add Extra Luggage',
  NOT_AVAILABLE: 'Baggage not available for this flight',
  DEFAULT_OPTION: 'Default',
} as const

export const ADDONS_MEAL_COPY = {
  MODAL_TITLE: 'Add in-flight meals to your journey',
  TITLE: 'Add delicious meals',
  ADDED: 'Meals added',
  NOT_AVAILABLE: 'Meal not available for this flight',
  NO_MEAL: 'No meal',
} as const

export const ADDONS_SEAT_COPY = {
  MODAL_TITLE: 'Add in-flight seats to your journey',
  TITLE: 'Add seats',
  ADDED: 'Seats added',
} as const

export const UI_NUDGE_SKIP_CTA = 'Skip and continue'
export const UI_NUDGE_UNAVAILABLE_PRIMARY_CTA = 'Remove coupon'
export const UI_NUDGE_UNAVAILABLE_SECONDARY_CTA = 'Go to itinerary'

export const getUiNudgeStayCta = (addonType?: string | null) => {
  const type = String(addonType || '').trim().toLowerCase()
  if (type === 'meal' || type === 'baggage' || type === 'seat') {
    return `Select ${type}`
  }
  return 'Select benefits'
}

export const INDIGO_UPFRONT_SEAT_MODAL_DATA = {
  title: 'Select your free seat',
  subText: 'Your Indigo Upfront booking comes with a free seat selection. Please make your selection to proceed.',
  primaryCta: 'Got it!',
}

export const INDIGO_UPFRONT_MEAL_MODAL_DATA = {
  title: 'Add your free meal',
  subText: 'Your Indigo Upfront booking comes with a free meal. Please add a meal to proceed.',
  primaryCta: 'Got it!',
}

export const INDIGO_UPFRONT_SEAT_MEAL_MODAL_DATA = {
  title: 'Select your free seat and meal',
  subText: 'Your Indigo Upfront booking comes with a free seat and meal. Please make your selection to proceed.',
  primaryCta: 'Got it!',
}

export const INDIGO_UPFRONT_SEAT_TOAST_MSG =
  "We've pre-selected this seat for you. You can continue or change it to proceed."
export const INDIGO_UPFRONT = 'INDIGO UPFRONT'

export const FETCH_ANCILLARY_TRIGGER_TYPE = {
  PRE_ITINERARY_REVIEW: 'PRE_ITINERARY_REVIEW',
  POST_ITINERARY_REVIEW: 'POST_ITINERARY_REVIEW',
}
